/**
 * Signup Page
 */

import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Logger, LogCategory } from '@/utils/logger';
import { useAuthStore } from '@/stores/authStore';
import { AuthLayout, LoginForm, SignupForm } from '@/components/auth';
import { ROUTES } from '@/constants';

export function SignupPage() {
  const navigate = useNavigate();
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const [mode, setMode] = useState<'login' | 'signup'>('signup');

  useEffect(() => {
    Logger.info(LogCategory.UI, 'SignupPage mounted', 'SignupPage', { isAuthenticated });

    // Redirect if already authenticated
    if (isAuthenticated) {
      Logger.info(LogCategory.NAVIGATION, 'User already authenticated, redirecting to dashboard', 'SignupPage');
      navigate(ROUTES.DASHBOARD, { replace: true });
    }
  }, [isAuthenticated, navigate]);

  return (
    <AuthLayout>
      <div className="w-full max-w-md">
        {/* Toggle Tabs */}
        <div className="mb-8">
          <div className="flex rounded-lg bg-slate-100 p-1">
            <button
              onClick={() => setMode('login')}
              className={`flex-1 py-2.5 text-sm font-medium rounded-md transition-all ${
                mode === 'login'
                  ? 'bg-white text-slate-900 shadow-sm'
                  : 'text-slate-600 hover:text-slate-900'
              }`}
            >
              Sign In
            </button>
            <button
              onClick={() => setMode('signup')}
              className={`flex-1 py-2.5 text-sm font-medium rounded-md transition-all ${
                mode === 'signup'
                  ? 'bg-white text-slate-900 shadow-sm'
                  : 'text-slate-600 hover:text-slate-900'
              }`}
            >
              Create Account
            </button>
          </div>
        </div>

        {/* Form Content */}
        {mode === 'login' ? <LoginForm /> : <SignupForm />}
      </div>
    </AuthLayout>
  );
}
